/** Insights (HU-1112/1113): por software e versão que corrige, com motivos de dispensa. */
export const INSIGHT_SEVERITIES = ['critical', 'high', 'medium', 'low'] as const;
export const DISMISS_REASONS = ['already-handled', 'risk-accepted', 'wrong-number', 'other'] as const;

export function insightTone(s?: string): 'crit' | 'warn' | 'info' | 'neutral' {
  return s === 'critical' ? 'crit' : s === 'high' ? 'warn' : s === 'medium' ? 'info' : 'neutral';
}
